/* libs */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

/* helpers */
import * as appsActions from "../../../actions/appsActions";
import GetItem from "../../../helpers/dataProviders/getItem";
import ChangeHistory from "../../shared/ChangeHistory";
import Loader from "../../ui/Loader";

/* components */
import AppForm from "./AppForm";

class EditApp extends Component {
	constructor(props) {
		super(props);
		this.appKey = props.match.params.appKey;
		this.state = {
			item: null,
		};
	}

	componentDidMount() {
		this.getItem();
	}

	onSubmit = values => {
		this.props.actions.editApp(this.appKey, values, () => {
			if (this.appKey !== values.key) {
				window.location = "/apps/" + values.key;
			} else {
				this.props.history.push("/apps/" + this.appKey);
			}
		});
	};

	getItem = () => {
		if (this.state.item === null) {
			GetItem(`/apps/${this.appKey}`).then(data => {
				this.setState({ item: data.data });
			});
		}
	};

	render() {
		const { item } = this.state;

		return (
			<div>
				<h3 className="page-title">Settings</h3>
				{item ? (
					<div className="ta-center">
						<ChangeHistory id={item.id} entity="apps" />
						<AppForm initialValues={item} onSubmit={this.onSubmit} />
					</div>
				) : (
					<div className="ta-center">
						<Loader />
					</div>
				)}
			</div>
		);
	}
}

const mapStateToProps = state => ({
	apps: state.apps,
});

const mapDispatchToProps = dispatch => ({
	actions: bindActionCreators(appsActions, dispatch),
});

EditApp.propTypes = {
	match: PropTypes.object,
	apps: PropTypes.object,
	actions: PropTypes.object,
	history: PropTypes.object,
};

export default withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(EditApp)
);
